import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "components/atoms/Button/IconButton";
import {
  disableAllMenu,
  isActiveSosongFlowChartModal,
} from "modules/actions/statusMenu";
import { sendSatisfy } from "modules/actions/starScore";
import {
  selectCategory,
  listBtnCategory,
} from "modules/actions/selectCategory";
import { setLevel1List } from "modules/actions/guideMap";
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';

import "./style.scss";
const SosongGuide = () => {
  const dispatch = useDispatch();
  const ref = useRef(null);
  const closeServiceGuide = () => {
    dispatch(selectCategory(''));
    dispatch(listBtnCategory(''));
    fallbackTabMove(['sosong_content','ri-close-line']);
    dispatch(disableAllMenu());
    document.querySelector('._additional_sosong').focus(); 
  };

  const categoryNameList = [
    "민사소송절차",
    "형사소송절차",
    "가사소송절차",
    "행정소송절차",
    "특허소송절차",
    "파산회생절차",
    "강제집행절차",
    "신청절차",
    "가족관계등록",
    "공탁절차",
    "소년보호",
    "가정보호",
  ];

  const onSosongFlowChart = (categoryName) => {
    dispatch(selectCategory(categoryName));
    dispatch(setLevel1List());
    dispatch(listBtnCategory());
    dispatch(isActiveSosongFlowChartModal());
  };

  useEffect(() => {
    disabledTabMoveButton(['sosong_content', 'ri-close-line']);
    disabledTabMoveInput();
  }, [])

  return (
    <div className="additional_area" ref={ref}>
      <button type="button" className="ri-close-line" onClick={closeServiceGuide} aria-label='닫기'/>
      <div className="ad_name ad_name_01">
        <img
          src={`${process.env.PUBLIC_URL}/images/svg/additional/addtionalSosongMain.svg`}
          alt=""
          style={{
            width: "18px",
            marginRight: "3px",
            top: "2.4px",
            position: "relative",
          }}
        />
        소송절차 안내도
      </div>
      <div className="sosong_box">
        {categoryNameList.map((name, idx) => {
          return (
            <button type="button"
              className="sosong_content"
              key={idx}
              onClick={() => onSosongFlowChart(name)}
            >
              {name}
            </button>
          );
        })}
      </div>
      <div className="sosong_usecase">
        <img
          src={`${process.env.PUBLIC_URL}/images/svg/additional/useGuide.svg`}
          alt="소송절차 안내도 이용법 소송분야를 선택하신 후 하위 대화주제를 확인해주세요.
          대화주제를 클릭하시면 대화창에서 챗봇이 바로 답변해드립니다.
          하위 대화주제 보기
          펼치기 버튼을 누르면 하위 목록이 펼쳐지고,
          닫기 버튼을 누르면 하위 목록이 다시 접힙니다.
          상세 내용 확인하기
          대화 주제를 클릭하면 대화창에서 자세한 내용을 확인할 수 있습니다."
        />
      </div>
    </div>
  );
};

export default SosongGuide;
